/* eslint-disable no-shadow */
enum Fields {
  PASSWORD_MIN_LENGTH = 6,
  EMAIL_MAX_LENGTH = 50,
}

export default Fields;
